import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";

const CredibilityNetwork = () => {
  const certifications = [
  {
    id: 1,
    name: "UNESCO World Heritage",
    year: "1999",
    description: "Recognized for outstanding universal value",
    icon: "Award"
  },
  {
    id: 2,
    name: "ASEAN Heritage Park",
    year: "2003",
    description: "Regional conservation excellence",
    icon: "Globe"
  },
  {
    id: 3,
    name: "Ramsar Wetland Site",
    year: "2012",
    description: "International wetland importance",
    icon: "Droplet"
  }];


  const partners = [
  {
    id: 1,
    name: "WWF Philippines",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1292240de-1765021426261.png",
    logoAlt: "WWF Philippines logo featuring iconic black and white panda symbol representing global wildlife conservation partnership"
  },
  {
    id: 2,
    name: "Conservation International",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_197e13692-1764691096267.png",
    logoAlt: "Conservation International logo with green leaf design symbolizing biodiversity protection and environmental stewardship"
  },
  {
    id: 3,
    name: "IUCN",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_197e13692-1764691096267.png",
    logoAlt: "IUCN International Union for Conservation of Nature logo with distinctive green and blue colors representing global conservation authority"
  },
  {
    id: 4,
    name: "Philippine Government",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a1cd7d5f-1765151405410.png",
    logoAlt: "Philippine government seal featuring national symbols and colors representing official government conservation support"
  }];


  const testimonials = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    role: "Marine Biologist, Stanford University",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1757e492a-1763293666438.png",
    avatarAlt: "Professional headshot of Caucasian female marine biologist with blonde hair in white lab coat smiling warmly",
    quote: "The underground river ecosystem represents one of the most pristine karst landscapes I\'ve studied in 20 years of research. The conservation management here sets a global standard.",
    rating: 5
  },
  {
    id: 2,
    name: "James Chen",
    role: "Eco-Tourism Specialist",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18177d561-1763301900808.png",
    avatarAlt: "Professional headshot of Asian male tourism specialist with short black hair in navy blue suit with confident expression",
    quote: "PPSRNP demonstrates how sustainable tourism can fund conservation while providing transformative visitor experiences. The balance they've achieved is remarkable.",
    rating: 5
  },
  {
    id: 3,
    name: "Maria Santos",
    role: "Local Community Leader",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4187c0d-1764781645173.png",
    avatarAlt: "Warm portrait of Filipino female community leader with dark hair wearing traditional clothing and welcoming smile",
    quote: "The park's community programs have created real economic opportunities for our families while teaching us to be guardians of our natural heritage.",
    rating: 5
  }];


  const impactMetrics = [
  { id: 1, value: "1.2M", label: "Annual Visitors", icon: "Users" },
  { id: 2, value: "95%", label: "Visitor Satisfaction", icon: "ThumbsUp" },
  { id: 3, value: "450+", label: "Research Publications", icon: "BookOpen" },
  { id: 4, value: "₱120M", label: "Community Economic Impact", icon: "TrendingUp" }];


  return (
    <section className="py-20 bg-[var(--color-card)]">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Certifications */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-foreground)] mb-12">
            Globally Recognized Excellence
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {certifications?.map((cert) =>
            <div
              key={cert?.id}
              className="bg-[var(--color-background)] rounded-xl p-6 border-2 border-[var(--color-accent)] hover:shadow-conservation-lg transition-all">

                <div className="w-16 h-16 bg-[var(--color-accent)]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon name={cert?.icon} size={32} color="var(--color-accent)" />
                </div>
                <div className="text-2xl font-bold text-[var(--color-foreground)] mb-2">
                  {cert?.name}
                </div>
                <div className="text-[var(--color-accent)] font-semibold mb-2">
                  Since {cert?.year}
                </div>
                <p className="text-sm text-[var(--color-muted-foreground)]">
                  {cert?.description}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Partners */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-[var(--color-foreground)] text-center mb-8">
            Conservation Partners
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {partners?.map((partner) =>
            <div
              key={partner?.id}
              className="bg-[var(--color-background)] rounded-lg p-6 flex items-center justify-center hover:shadow-conservation transition-all">

                <div className="w-24 h-24 rounded-lg overflow-hidden">
                  <Image
                  src={partner?.logo}
                  alt={partner?.logoAlt}
                  className="w-full h-full object-cover" />

                </div>
              </div>
            )}
          </div>
        </div>

        {/* Testimonials */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-[var(--color-foreground)] text-center mb-12">
            What Experts Say
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials?.map((testimonial) =>
            <div
              key={testimonial?.id}
              className="bg-[var(--color-background)] rounded-xl p-6 border border-[var(--color-border)]">

                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial?.rating)]?.map((_, i) =>
                <Icon
                  key={i}
                  name="Star"
                  size={16}
                  color="var(--color-accent)" />

                )}
                </div>
                <p className="text-[var(--color-muted-foreground)] mb-6 italic">
                  "{testimonial?.quote}"
                </p>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-full h-full object-cover" />

                  </div>
                  <div>
                    <div className="text-[var(--color-foreground)] font-semibold">
                      {testimonial?.name}
                    </div>
                    <div className="text-sm text-[var(--color-muted-foreground)]">
                      {testimonial?.role}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Impact Metrics */}
        <div className="bg-gradient-conservation rounded-2xl p-8">
          <h3 className="text-3xl font-bold text-[var(--color-foreground)] text-center mb-8">
            Conservation Impact
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {impactMetrics?.map((metric) =>
            <div key={metric?.id} className="text-center">
                <div className="w-16 h-16 bg-[var(--color-accent)]/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Icon name={metric?.icon} size={28} color="var(--color-accent)" />
                </div>
                <div className="text-4xl font-bold text-[var(--color-accent)] mb-1">
                  {metric?.value}
                </div>
                <div className="text-sm text-[var(--color-muted-foreground)]">
                  {metric?.label}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default CredibilityNetwork;